import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { Config } from 'src/app/services/env.config';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';
import { WaitingDialogComponent } from 'src/app/shared/waiting-dialog/waiting-dialog.component';
import { AbmPopupComponent } from '../abm-popup/abm-popup.component';
import { DdPopupComponent } from '../dd-popup/dd-popup.component';
import { IddPopupComponent } from '../idd-popup/idd-popup.component';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'app-dealer-dashboard',
  templateUrl: './dealer-dashboard.component.html',
  styleUrls: ['./dealer-dashboard.component.scss']
})
export class DealerDashboardComponent implements OnInit {

  xlname: any;
  xldata: any;
  @ViewChild('downloads', { static: true }) divClick: ElementRef;
  @ViewChild('exportModal', { static: true }) public downloadModalOnClick: ModalDirective;
  
  constructor(public reportsService: ReportsService, private sanitizer: DomSanitizer, private modalService: MDBModalService) { 
    this.fromDateValue.setDate(this.fromDateValue.getDate() - 30);
    this.fromDateValue =  moment(this.fromDateValue).format('YYYY-MM-DD');
  }
  fromDate: any = '01-01-2022';
  toDate: any = '31-01-2022';
  toDateValue = moment(new Date()).format('YYYY-MM-DD');
  fromDateValue: any = new Date(); 
  MaxToDate :any  = moment(new Date()).format('YYYY-MM-DD');
  today = moment(new Date()).format('YYYY-MM-DD'); 
  tableData :any[] = [];
  abmTable :any[] = [];
  rsmTable :any[] = [];
  ngOnInit() {
    this.getDashboardReport();
  }

  onDateChange(event) {
    console.log("from", this.fromDateValue);
    console.log("to", this.toDateValue);
    let date = new Date(this.fromDateValue);
    date.setDate(date.getDate() + 30);
    this.MaxToDate =  moment(date).format('YYYY-MM-DD');
    this.toDateValue = moment(date).format('YYYY-MM-DD');
    // this.getReports();
  }

  getDashboardReport() {
      this.reportsService.getDashboardReportABM(this.fromDateValue, this.toDateValue).then((data: any) => {
         this.tableData = data;
         }, errorCode => console.log(errorCode));
  }

  successModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
  export(){
          this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
        data: {
          message: 'please wait'
        }
      });
    this.reportsService.export_dashboard_abm(this.fromDateValue ,this.toDateValue).then((data) => {
         console.log(data,'data')
       
         if (data.File) {
          setTimeout(x => {
            this.waitingModalRef.hide()
          }, 100)
        this.xlname = data.FileName;
        let url = 'data:application/octet-stream;base64,'+  data.File;
        this.xldata =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        setTimeout(() => {
          this.divClick.nativeElement.click();
          }, 200);
          this.downloadModalOnClick.hide();
        }
        else {
          setTimeout(x => {
            this.waitingModalRef.hide()
          }, 100)
          let message = "There is no file available for Export";
          this.successModalRef = this.modalService.show(SuccessDialogComponent, {
            data: {
              message: message,
              data: []
            }
          });
          this.successModalRef.content.action.subscribe(result => {
            if (result == 'OK') {
              this.successModalRef.hide();
            }
          })
         
        }
 })

}

}
